export default __webpack_public_path__ + "static/media/bmw-side-nav-series-complete.b00d1db0.svg";